<template>
    <div>
        <el-dialog v-if="dialogVisible" destroy-on-close :close-on-click-modal="false" :visible.sync="handleCloseList" width="1000px" :title="title">
            <el-form :model="vo">
                <div style="width: 96%; margin-top: 10px; margin-bottom: 20px" class="el-table el-table--fit el-table--border">
                    <div class="el-table__body-wrapper">
                        <table cellspacing="0" cellpadding="0" border="0" class="el-table__body">
                            <tbody>
                                <tr>
                                    <td ref="tdlbl_保证金是否已退还" class="el-table__cell tdlbl tdw17" colspan="1">
                                        <span class="required">*</span>
                                        <span v-field-lbl="'guaranteedAmountReturnInfo'" class="field">保证金是否已退还</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw33" colspan="2">
                                        <form-item
                                            ref="guaranteedAmountReturnInfo"
                                            :field="{
                                                defaultValue: '是',
                                                elementCanEdit: '{${canEdit}}',
                                                elementCssHeight: null,
                                                elementCssWidth: null,
                                                elementFormatter: '是：是\n否：否',
                                                elementReadonly: 1,
                                                elementType: 'radio',
                                                emptyMessage: '请选择保证金是否已退还',
                                                errorMessage: null,
                                                isRequired: 1,
                                                onClickEvent: null,
                                                passenger: {},
                                                propComment: '保证金是否已退还',
                                                propName: 'guaranteedAmountReturnInfo',
                                                propType: 'String',
                                                textFormatter: null,
                                                valueMaxLength: null,
                                                valueMinLength: null,
                                                tbFieldName: 'guaranteedamountreturninfo',
                                                iconName: 'dxk',
                                                model: 'vo.guaranteedAmountReturnInfo',
                                                option: [
                                                    { value: '是', name: '是' },
                                                    { name: '否', value: '否' }
                                                ],
                                                formTdAlign: 'text-left',
                                                optionGenerateType: 0,
                                                clearable: false,
                                                filterable: false,
                                                allowCreate: false,
                                                remoteMethod: '',
                                                labelMinWidth: ''
                                            }"
                                            :vo="vo"
                                            :can-edit="canEdit"
                                        />
                                    </td>
                                    <td ref="tdlbl_退回日期" class="el-table__cell tdlbl tdw17" colspan="1">
                                        <span v-field-lbl="'returnTime'" class="field">退回日期</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw33" colspan="2">
                                        <form-item
                                            ref="returnTime"
                                            :field="{
                                                defaultValue: null,
                                                elementCanEdit: '{${canEdit}}',
                                                elementCssHeight: null,
                                                elementCssWidth: null,
                                                elementFormatter: null,
                                                elementReadonly: 1,
                                                elementType: 'date',
                                                emptyMessage: '请选择退回日期',
                                                errorMessage: null,
                                                formTdAlign: 'text-left',
                                                formTdColspan: 0,
                                                isRequired: 0,
                                                onClickEvent: null,
                                                passenger: {},
                                                propComment: '退回日期',
                                                propName: 'returnTime',
                                                propType: 'java.util.Date',
                                                textFormatter: 'yyyy-MM-dd',
                                                valueMaxLength: null,
                                                valueMinLength: null,
                                                model: 'vo.returnTime',
                                                option: [],
                                                weekday: 0,
                                                disabledDate: 'returnTimeDisabledDate',
                                                defaultTime: ''
                                            }"
                                            :vo="vo"
                                            :can-edit="canEdit"
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button v-for="(btn, key) in formBtns" :key="key" :disabled="doing" :plain="btn.btnType === null || btn.btnType === ''" :icon="'el-icon-' + btn.btnIcon" :type="btn.btnType !== null ? btn.btnType : ''" @click="btn.btnClick">{{ btn.btnName }}</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
const moment = require('moment')
export default {
    props: {
        // vo: {
        //     type: Object,
        //     default: () => ({})
        // },
        canEdit: {
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            title: '退还保证金',
            dialogVisible: false,
            vo: {},
            formBtns: [
                {
                    id: 'btn_close',
                    btnName: '关 闭',
                    btnIcon: 'close',
                    btnClick: this.handleCloseList,
                    btnPermission: '',
                    btnType: ''
                },
                {
                    id: 'btn_save',
                    btnName: '保 存',
                    btnIcon: 'check',
                    btnClick: this.submitBusiform,
                    btnPermission: 'saveObject',
                    btnType: 'primary'
                }
            ],
            study: '',
            percenNum: ''
        }
    },
    computed: {},
    watch: {},
    created() {
        this.$bus.on('showTbbzjDialog', this.handleShowList)
        this.$bus.on('closeTbbzjDialog', this.handleCloseList)
    },
    beforeDestroy() {
        this.$bus.off('showTbbzjDialog', this.handleShowList)
        this.$bus.off('closeTbbzjDialog', this.handleCloseList)
    },
    mounted() {},
    methods: {
        handleShowList(row) {
            // this.dialogVisible = true
            // this.fetchData()
            let url = ''
            url = 'tbgl/tbbzjsq/addNew'
            this.addNew(url, row)
        },
        handleCloseList() {
            this.dialogVisible = false
        },
        async addNew(url, item) {
            console.log(item)
            // const res = await this.$app.addNew(url)
            // if (res.code === 'success') {
            // res.body.vo.flCreator = this.loginUser.personName
            // res.body.vo.flCreatorPhone = this.loginUser.personMobile
            // res.body.vo.phone = item[0].mobilePhone
            // res.body.vo.creatorId = this.loginUser.personId
            // res.body.vo.name = item[0].name
            // res.body.vo.archivesId = item[0].id
            // res.body.vo.beforeDept = item[0].department
            // res.body.vo.flCreateDept = item[0].department
            // res.body.vo.beforeDeptId = item[0].orgFullId
            // res.body.vo.orgFullId = item[0].orgFullId
            // res.body.vo.post = item[0].post || item[0].jobPost
            // res.body.vo.employeeNo = item[0].employeeNo || ''
            // res.body.vo.idCardNumber = item[0].idCardNumber || ''
            // debugger
            // res.body.vo.status = 1
            // res.body.vo.staffDept = item[0].department
            // // res.body.vo.flSubject = item[0].quitReason
            // res.body.vo.options = []
            // res.body.vo.passenger.quitTypeOptions.forEach((item) => {
            //     const obj = {
            //         label: '',
            //         value: ''
            //     }
            //     obj.label = item.text
            //     obj.value = item.value
            //     res.body.vo.options.push(obj)
            // })
            // res.body.vo.staffName = item[0].name
            // res.body.vo.mobilePhone = item[0].mobilePhone
            // if (item[0].passenger && item[0].passenger.appointmnetInfoList && item[0].passenger.appointmnetInfoList[0] && item[0].passenger.appointmnetInfoList[0].department) {
            //     res.body.vo.staffDept = item[0].passenger.appointmnetInfoList[0].department
            //     res.body.vo.staffDeptId = item[0].passenger.appointmnetInfoList[0].orgFullId
            // }
            // res.body.vo.entryDate = item[0].entryDate

            // this.vo = res.body.vo

            // this.$http({
            //     url: `rsgl/appointmnetInfo/getByArchiveId?id=${item[0].id}`,
            //     method: 'GET'
            // }).then(async (res) => {
            //     if (res.code === 'success') {
            //         console.log(res)
            //         const newArr = []
            //         res.body.listdata.forEach((depr) => {
            //             if (!newArr.includes(depr.department)) {
            //                 newArr.push(depr.department)
            //                 const obj = {
            //                     value: depr.department,
            //                     label: depr.department
            //                 }
            //                 this.options.push(obj)
            //             }
            //             this.deptmentData = res.body.listdata
            //             if (depr.orgFullId === item[0].orgFullId) {
            //                 // item[0].postRank = depr.postRank
            //                 this.vo.postRank = depr.postRank
            //                 this.vo.flCreateDept = depr.department
            //             }
            //         })
            //     } else {
            //         this.$message.error(res.message)
            //     }
            // })
            this.dialogVisible = true
            // } else {
            // this.$message.error(res.message)
            // }
        },
        submitBusiform() {
            this.formValidate(
                () => {
                    console.log(this.vo)
                    // this.vo.applyDate = this.vo.estimateQuitDate
                    // this.vo.actualQuitDate = this.vo.estimateQuitDate
                    // this.vo.staffDeptId = this.vo.orgFullId
                    // this.$http({
                    //     url: 'rsgl/lizhiManage/insert',
                    //     method: 'POST',
                    //     data: this.vo
                    // }).then(async (res) => {
                    //     if (res.code === 'success') {
                    //         console.log(res)
                    //         this.$message.success(res.message)
                    //         this.$bus.emit('refreshListData')
                    //     } else {
                    //         this.$message.error(res.message)
                    //     }
                    //     this.closeDialog()
                    // })
                },
                null,
                this.canEdit
            )
        }
    }
}
</script>

<style lang="scss" scoped>
.container {
    padding-top: 10px;
    .topTitle {
        padding-left: 20px;
        display: flex;
        font-family: 'Arial Normal', 'Arial';
        font-weight: 400;
        font-size: 16px;
        .study-title {
            font-family: 'Arial Negreta', 'Arial Normal', 'Arial';
            font-weight: 700;
            font-size: 18px;
        }
    }
    .pic {
        width: 560px;
        height: 300px;
    }
}
</style>
